import { FC } from 'react';
import { Typography } from '@mui/material';
import { Grid } from '@mui/system';
import { DefaultPanelComponentProps } from 'pages/ValuationsAllocation/types';
import { getStringValue } from 'utilities';

const DefaultPanelComponent: FC<DefaultPanelComponentProps> = props => {
  const { approach } = props;

  return (
    <Grid>
      <Typography>
        Component for valuation approach {getStringValue(approach.approach_type)} has not been implemented
      </Typography>
    </Grid>
  );
};

export default DefaultPanelComponent;
